<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="3">
        <el-button type="success" @click="sendMessage"  size="mini">更新员工状态并推送消息</el-button>
      </el-col>
      <el-col :span="3">
        <el-input placeholder="职位" v-model="params.position" style="width: 100%" size="mini"></el-input>
      </el-col>
      <!-- <el-col :md="8" :lg="4">
          <el-select size="small" v-model="params.wx_main_department_id" clearable placeholder="部门" @change="typesearch">
              <el-option v-for="item in deplist" :key="item.id" :label="item.name" size="mini" :value="item.id"> </el-option>
          </el-select>
      </el-col> -->
      <!-- 部门列表弹窗 -start  -->
      <el-col :span="5">
        <el-button class="iconfont icon-sync-alt" @click="handleClick" style="width: 100%" size="mini"> {{corpName}}</el-button>
        <depTree :visible="visible" :data="checked" @onClose="handleClose" @change="handleChange"></depTree>
      </el-col>
         </el-row>
    <el-row :gutter="24">
       <!-- 部门列表弹窗 -end  -->
      <el-col :span="3">
        <el-input placeholder="姓名" v-model="params.name" style="width: 100%" size="mini"></el-input>
      </el-col>
        <el-col :span="3">
         <el-select v-model="params.gender" placeholder="性别" size="mini">
        <el-option label="全部" value=""></el-option>
        <el-option label="男" value="1"></el-option>
        <el-option label="女" value="2"></el-option>
      </el-select>
      </el-col>
      <el-col :span="3">
         <el-select v-model="params.status" placeholder="激活状态" size="mini">
        <el-option label="已激活" value="1"></el-option>
        <el-option label="已禁用" value="2"></el-option>
        <el-option label="未激活" value="4"></el-option>
        <el-option label="退出企业" value="5"></el-option>
      </el-select>
      </el-col>
         <el-col :span="3">
        <el-input placeholder="门店id" v-model="params.distributor_number" style="width: 100%" size="mini"></el-input>
      </el-col>
        <el-col :span="3">
        <el-input placeholder="员工编号" v-model="params.wx_user_id" style="width: 100%" size="mini"></el-input>
      </el-col>
       <el-col :span="3">
        <el-input placeholder="用户id" v-model="params.yaoking_user_id" style="width: 100%" size="mini"></el-input>
      </el-col>
      <el-col :span="3">
        <el-input placeholder="手机号" v-model="params.phone" style="width: 100%" size="mini"></el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
          <el-button type="primary" @click="searchData"  size="mini">搜索</el-button>

           <el-button size="mini" type="primary" @click="exportData">导出</el-button>
           <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
      </el-col>
    </el-row>
    <el-table :data="catesList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" ></el-table-column>

      <el-table-column prop="name" label="姓名" >
        <template slot-scope="scope">
            {{ scope.row.name }} 
            <el-tag v-if="scope.row.store_tag"  size="mini" type="success" effect="dark">{{ scope.row.store_tag }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="thumb_avatar" label="头像" >
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right">
                 <img :src="scope.row.avatar" style="width:200px;height:200px;" :alt="scope.row.name">
                <div slot="reference" class="name-wrapper">
                  <img :src="scope.row.thumb_avatar" style="width:30px;height:30px;" :alt="scope.row.name">
                </div>
              </el-popover>
        </template>
      </el-table-column>

      <el-table-column prop="mobile" label="手机号"></el-table-column>
      <el-table-column prop="wx_user_id" label="微信userid"></el-table-column>
       <el-table-column prop="yaoking_user_id" label="用户id" ></el-table-column>
      <el-table-column prop="main_department" label="部门" ></el-table-column>
      <el-table-column prop="distributor_number" label="门店id" ></el-table-column>
      <el-table-column prop="gender" label="性别" >
          <template slot-scope="scope">
              <el-tag size="mini" effect="plain" type="success" v-if="scope.row.gender=='1'">男性</el-tag>
              <el-tag size="mini" effect="plain" v-else-if="scope.row.gender=='2'">女性</el-tag>
              <el-tag size="mini" effect="plain" v-else>未知</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="status" label="激活状态">
          <template slot-scope="scope">
              <el-tag size="mini" effect="plain" type="success" v-if="scope.row.status=='1'">已激活</el-tag>
              <el-tag size="mini" effect="plain" v-else-if="scope.row.status=='2'">已禁用</el-tag>
              <el-tag size="mini" effect="plain" v-else-if="scope.row.status=='4'">未激活</el-tag>
              <el-tag size="mini" effect="plain" v-else>退出企业</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="position" label="对外职位" ></el-table-column>
    <el-table-column   label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="setTag(scope.row,scope.$index)">标记店长</el-button>
            <el-button type="text" @click="update(scope.row,scope.$index)">更新</el-button>
            <el-button type="text" @click="edit(scope.row,scope.$index)">编辑</el-button>
            <el-button type="text" @click="toDeleteEmployeeUser(scope.row,scope.$index)">删除</el-button>
          </template>
      </el-table-column>

    </el-table>
     <div class="content-center content-top-padded">
          <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[10,20,50]"
                  :total="total_count"
                  :page-size="params.pageSize">
          </el-pagination>
      </div>
      <el-dialog title="编辑信息" :visible.sync="dialogFormVisible" >
      <el-form :model="editFrom">
        <el-form-item label="员工编号" >
          <el-input v-model="editFrom.userid" readonly="true" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="姓名" >
          <el-input v-model="editFrom.name" readonly="true" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="店铺id" >
          <el-input v-model="editFrom.distributor_number" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import depTree from './depTree'
  import { getEmployee,getSnyEmployee,employeeExport,deleteEmployeeUser,getEmployeeInfo,setStoreTags,updateUser,getAllUserIds} from '../../../api/workwx'
  export default {
    components: {
      depTree,
    },
    data () {
      return {
        editFrom:{
          distributor_number:'',
          userid:'',
        },
        total_count: 0,
        params: {
          page: 1,
          pageSize: 20,
        },
        deplist:[],
        catesList:[],
        loading:false,
        memberTagDialog: false,
        visible:false,
        checked: {},
        corpName:"点击切换部门",
        memberTagDialog: false,
        crop_id:null,
        dialogFormVisible:false,
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      sendMessage(){
        this.$confirm('你确定更新并推送员工信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            getAllUserIds({is_send:1,is_update:1}).then(res=>{
                  this.$message({
                     type: res.data.data.status == true ?'success':'error',
                     message: res.data.data.msg
                  });
                  this.dialogFormVisible = false;
                  this.params.page = 1
                  this.getDataList()
                })

          }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
          });
      },
      edit(row,index){
        this.dialogFormVisible = true;
        this.editFrom.userid = row.wx_user_id;
        this.editFrom.name = row.name;
        this.editFrom.distributor_number = row.distributor_number;
      },
      editSubmit(){
        this.$confirm('你确定更新该员工信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            updateUser(this.editFrom).then(res=>{
                  this.$message({
                     type: res.data.data.status == true ?'success':'error',
                     message: res.data.data.msg
                  });
                  this.dialogFormVisible = false;
                  this.params.page = 1
                  this.params.wx_user_id = this.editFrom.userid;
                  this.getDataList()
                })

          }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
          });
      },
      update(row,index){
        this.$confirm('你确定更新该员工?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            getEmployeeInfo({userid:row.wx_user_id,is_update:1}).then(res=>{
                  this.$message({
                     type: res.data.data.status == true ?'success':'error',
                     message: res.data.data.msg
                  });
                  this.params.page = 1
                  this.getDataList()
                })

          }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
          });
      },
      setTag(row,index){
        this.$confirm('你确定要标记该人员，该店铺其他人员将移除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            setStoreTags({distributor_number:row.distributor_number,wx_user_id:row.wx_user_id}).then(res=>{
                  this.$message({
                     type: res.data.data.status == true ?'success':'error',
                     message: res.data.data.msg
                  }); 
                  this.params.page = 1
                  this.getDataList()
                })

          }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
          });
      },
      toDeleteEmployeeUser(row,index){
          this.$confirm('你确定要删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
              deleteEmployeeUser(row.id).then(res=>{
                  this.$message({
                     type: res.data.data.status == true ?'success':'error',
                     message: res.data.data.msg
                  });
                   if(res.data.data.status){
                        setTimeout(()=>{
                            this.catesList.splice(index,1)
                        },2000)
                   }
                })

          }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
          });

      }, 
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      handleClick () {
        this.visible = true
      },
      handleClose () {
        this.visible = false
      },
      handleResetClick () {
        this.$emit('change', {})
      },
      handleChange (arr) {
        this.params.department_id = arr.wx_department_id
        this.params.corp_id = arr.corp_id
        this.corpName = arr.name?arr.name:arr.cropname
        this.visible = false
      },
      addTemplate () { // 添加商品
        this.$confirm('此操作将进行数据同步变更, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            if(this.params.corp_id==undefined || this.params.corp_id==null){
            this.$message({
              type: 'error',
              message: '请选择企业'
            })
            return false;
          }else{
            getSnyEmployee({'corp_id':this.params.corp_id}).then(res=>{
              this.$message({
                type: 'success',
                message: '已加入队列!'
              })
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消同步数据'
          });
        });
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      typesearch () {
        this.params.page = 1
        this.getDataList()
      },
      handleSizeChange (pageSize) {
          this.params.page = 1
          this.params.pageSize = pageSize
          this.getDataList()
      },
      getDataList () {

        this.loading = true
        console.log(this.params)
        getEmployee(this.params).then(response => {

          this.catesList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.deplist = response.data.data.dep
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      exportData(){
       this.params.page = 1
        employeeExport(this.params).then(response => {
           if (response.data.data.status) {
              this.downloadUrl = response.data.data.url
              this.downloadName = response.data.data.filename
              this.downloadView = true
              this.$message({
                type: 'success',
                message: '已加入执行队列，请在设置-导出列表中下载'
              })
          } else {
            this.$message({
              type: 'error',
              message: '无内容可导出 或 执行失败，请检查重试'
            })
            return
          }
        })
      },
      },
       mounted () {
        this.getDataList()
      }

    }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// employee.vue?7bd07bbc